// extracted by mini-css-extract-plugin
module.exports = {"userFormWrapper":"UserFormWrapper_userFormWrapper__20gFt","logo":"UserFormWrapper_logo__2mkj7"};